export const config = {
  "api": "https://imcd-be.scapp.work/api/v1"
}
